import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

// import logo from '../../assets/images/resmed-online-store.jpg';
import logo from "../../assets/images/resmed-onlinestore-logo.png";
import i18n from "../../i18n";

const { VITE_REDIRECT_TO_OLD_URL } = import.meta.env;

function Logo({ login }) {
  const { error401 } = useSelector((state) => state.authentication);
  const { formattedMenu } = useSelector((state) => state?.headerProductSearch);
  const navModule =
    formattedMenu && formattedMenu?.find((a) => a?.type === "Link");
  return (
    <div className="logo">
      {error401 ? (
        <a href={VITE_REDIRECT_TO_OLD_URL}>
          <img
            src={logo}
            title={i18n?.t("header.onlineStore")}
            alt={i18n?.t("header.onlineStore")}
          />
        </a>
      ) : (
        <NavLink
          to={
            login && navModule
              ? `${
                  navModule?.name === "warranty" ? "/return" : navModule?.link
                }`
              : "#"
          }
        >
          <img
            src={logo}
            title={i18n?.t("header.onlineStore")}
            alt={i18n?.t("header.onlineStore")}
          />
        </NavLink>
      )}
    </div>
  );
}
export default Logo;
